import {
    CFG_SI_FEEDS_URL_BASE,
    SPORT_IDS
} from "../../../assets/js/config";
import { getMatch, startHTTPRequest } from "../../../assets/js/common";

const MatchErrorStatusIds = {
    "1": [130],
    "2": []
}
const eventsToConsider = [
    // 1,/* start of first and second half */
    // 2,/* Foul */
    // 3,/* Free Kick */
    // 4,/* Cross */
    // 5,/* Goal Kick */
    // 6,/* Off Target */
    // 7,/* Corner */
    // 8,/* On Target */
    9,/* Goal */
    // 10,/* Offside */
    11,/* Half Time */
    12,/* Yellow Card */
    13,/* Substitution */
    // 14,/* Match Completed */
    // 15,/* Throw-In */
    16,/* Own Goal */
    17,/* Goal-Penalty */
    18,/* Red Card */
    // 34,/* Blocked Shot */
];

const scorecard_store = {
    namespaced: true,
    state: () => ((typeof window !== "undefined" && window.__ROI_STATE_DATA__ && window.__ROI_STATE_DATA__.scorecard_store) ? window.__ROI_STATE_DATA__.scorecard_store : {
        page: 'team page',
        scorecards_store_filled: false,
        isLoading: true,
        realtime_update: null,
        cricketScore: null,
        footballTimeline: null
    }),
    actions: {
        fetchMatchFile: ({ state, rootState, dispatch }) => {
            let { match_detail_store } = rootState;

            if (match_detail_store.no_matches_active) return;

            let match = getMatch(match_detail_store.match_data, "slug", match_detail_store.slug);
            if (match) {
                let { code: match_code, sport_id, league_code, status } = match;
                let apiUrl = "";
                if(sport_id == SPORT_IDS.football && league_code) {
                    apiUrl = `${CFG_SI_FEEDS_URL_BASE}football/live/${league_code}/json/${match_code}.json`;
                } else if(sport_id == SPORT_IDS.cricket) {
                    apiUrl = `${CFG_SI_FEEDS_URL_BASE}cricket/live/json/${match_code}.json`;
                }

                if (apiUrl) {
                    return startHTTPRequest({
                        method: "GET",
                        url: apiUrl,
                        can_append: false,
                        addAuthorization: false
                    })
                        .then((res) => {
                            let isLiveScoreActive = false, isLiveScoringActive = (match_detail_store && match_detail_store.isLiveScoringActive);
                            if (sport_id == SPORT_IDS.football) {
                                let {events, teams: teamList} = res;
                                let sortedEvents = (events || []).filter(
                                    evt => eventsToConsider.includes(+evt.event_id)
                                );
                                state.realtime_update = null;
                                state.cricketScore = null;
                                state.footballTimeline = { eventList: sortedEvents, teamList };
                            } else if(sport_id == SPORT_IDS.cricket) {
                                let {Matchdetail, Innings: innList, Teams: teamList} = res;
                                let matchSummary = {};
                                if((MatchErrorStatusIds[sport_id] || []).includes(+Matchdetail.Status_Id)) {
                                    matchSummary.status = Matchdetail.Status;
                                }
                                if(Matchdetail && Matchdetail.Equation) {
                                    matchSummary.equation = Matchdetail.Equation;
                                }
                                if(Matchdetail && Matchdetail.Player_Match) {
                                    matchSummary.man_of_match = {
                                        name: Matchdetail.Player_Match,
                                        player_id: Matchdetail.Player_Match_Id,
                                        team_id: Matchdetail.Player_Match_TeamId
                                    }
                                }
                                if(Matchdetail && Matchdetail.Player_Series) {
                                    matchSummary.man_of_series = {
                                        name: Matchdetail.Player_Series,
                                        player_id: Matchdetail.Player_Series_Id,
                                        team_id: Matchdetail.Player_Series_TeamId
                                    }
                                }

                                let realTimeUpdate = null;
                                if(Matchdetail && !Matchdetail.Result) {
                                    isLiveScoreActive = true;
                                    if(Matchdetail && Matchdetail.Tosswonby) {
                                        if(status == -2) {
                                            realTimeUpdate = { matchFixture: null, scoreboard: 10000 }
                                        } else {
                                            realTimeUpdate = { matchFixture: 20000, scoreboard: 20000 }
                                        }
                                    } else {
                                        if(status == -2) {
                                            realTimeUpdate = { matchFixture: null, scoreboard: 20000 }
                                        } else {
                                            realTimeUpdate = { matchFixture: 40000, scoreboard: 40000 }
                                        }
                                    }
                                }

                                state.realtime_update = realTimeUpdate;
                                state.footballTimeline = null;
                                state.cricketScore = { innList, teamList, matchSummary };
                            }
                            state.scorecards_store_filled = true;
                            if(isLiveScoreActive !== isLiveScoringActive) {
                                dispatch("match_detail_store/setLiveScoringFlag", isLiveScoreActive, { root: true });
                            }
                        })
                        .catch((e) => {
                            state.footballTimeline = null;
                            state.cricketScore = null;
                            state.scorecards_store_filled = true;
                            console.log(e);
                            console.log(e.toString());
                        });
                } else {
                    state.realtime_update = null;
                    state.footballTimeline = null;
                    state.cricketScore = null;
                    state.scorecards_store_filled = true;
                }
            }
        },
        resetScorecard: ({ state }) => {
            state.realtime_update = null;
            state.footballTimeline = null;
            state.cricketScore = null;
        }
    }
}

export default scorecard_store;